import { render, staticRenderFns } from "./return-amount.vue?vue&type=template&id=4384e4a5&lang=pug"
import script from "./return-amount.vue?vue&type=script&lang=js"
export * from "./return-amount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports